import {TCallbackUrl, TUrlType} from './definitions';

export const getCallbackUrlByType = (items: TCallbackUrl[], type: TUrlType): TCallbackUrl =>
  items.find((item) => item.type === type) || {
    type,
    locked: false,
    url: '',
  };
